import React, { Component } from 'react';
import './reminder.scss';
import { Constants, ImageConstants } from '../../../constants/constants';
import HomeworkApi from '../../../apis/homework'
import { getImageSource } from '../../../utility/image-source'
import moment from 'moment';
class Reminder extends Component {

    state = {
        message: this.props.message
    }

    componentDidMount() {
    }

    onClickSend = () => {
        if (this.saving || this.props.notCompleted == 0) return
        this.saving = true

        let payload = {
            homeworkId: this.props.homeworkId,
            message: this.state.message
        }

        HomeworkApi.homeworkReminder(payload).then(data => {
            this.saving = false
            this.onClickBack()
        }).catch(err => {
            this.saving = false
        })
    }
    onClickBack = () => {
        this.props.back()
    }

    onClickInfo = () => {
        this.setState({ showInfoModal: true })
    }

    hideInfoModal = () => {
        this.setState({ showInfoModal: false })
    }

    getColor(skill) {
        let colors = Constants.SKILLS_COLOR
        let color = colors[skill]
        return color
    }

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event?.target?.value })
    }

    reminderNote() {
        let count = this.props.notificationCount
        let day = moment(moment()).diff(moment(this.props.notificationDate), 'days')
        if (!day) {
            return `${count} Reminders sent already today`
        }
        return `${count} Reminders sent already, Last sent ${day} days back`
    }

    render() {
        return (
            <div className='reminder'>

                <div className="abs-image">
                    <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                </div>
                <div className="row pt-4">
                    <div className="col text-right my-auto"><img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={() => this.onClickBack()} /></div>
                </div>

                <div className="">
                    <div className="title">Send a Reminder </div>
                    {this.props.notificationCount ? <div className="note">{this.reminderNote()}</div> : ""}
                </div>
                <div className="row pt-4">
                    <div className="col-12">
                        <lable className="message-lable pl-2">Message</lable>
                        <div className="message">
                            <textarea className="message-input" placeholder='Enter a Message'
                                value={this.state.message}
                                onChange={(e) => this.onChangeHandler(e, 'message')} />
                        </div>
                    </div>
                </div>
                <div className="counter text-right pt-2">{`${this.state.message?.length || 0} / 300`}</div>
                <div className="note pt-2">{this.props.note || `Reminder message will be sent as App Notification to ${this.props.notCompleted || 0} students, who have not completed the Schoolwork yet`}</div>
                <div className="pt-4">
                    <button className={`cw-btn-md d-inline-block cw-btn-primary ${this.props.notCompleted == 0 ? "disable-button" : ""}`} onClick={() => this.onClickSend()}>
                        SEND REMINDER
                    </button>
                </div>
            </div >
        );
    }
}

export default Reminder;